export default __webpack_public_path__ + "static/work-bg-e337a40b2e157d327a64536ef09ade72.svg";